/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespProminentTileDescription_item$ref = any;
export type SbRespProminentTileDescription_item = {
    readonly quickViewDisplay: {
        readonly paragraphs: ReadonlyArray<{
            readonly key: string | null;
            readonly text: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": SbRespProminentTileDescription_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespProminentTileDescription_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "quickViewDisplay",
      "storageKey": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "paragraphs",
          "storageKey": null,
          "args": null,
          "concreteType": "QuickViewParagraph",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "key",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "text",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'f77cbfacc323e0e13cdae6c89f4ea9a7';
export default node;
